import React, { useContext, useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import { Button } from "react-bootstrap";
import toast from "react-hot-toast";
import { FaGift, FaWandMagicSparkles } from "react-icons/fa6";
import PlansModal from "./PlansModal";
import TopupModal from "./TopupModal";
import { claimTrial } from "../../../api/context/billing";
import { SelectionContext } from "../../../Context/Store";

const PaywallModal = ({
  isOpen,
  toggle,
  balance,
  message,
  trialAvailable,
}) => {
  const { refreshBillingBalance } = useContext(SelectionContext);
  const [showPlans, setShowPlans] = useState(false);
  const [showTopup, setShowTopup] = useState(false);
  const [claiming, setClaiming] = useState(false);

  const subRemaining = balance?.subscription?.remaining ?? 0;
  const walletBalance = balance?.wallet?.balance ?? 0;
  const grantAmount = balance?.trial?.grantAmount ?? 3;

  const handleClaim = async () => {
    setClaiming(true);
    try {
      const res = await claimTrial();
      const granted = res?.data?.data?.granted ?? grantAmount;
      toast.success(
        `🎉 You've unlocked ${granted} free credit${granted === 1 ? "" : "s"}!`,
        { duration: 5000 }
      );
      refreshBillingBalance();
      toggle();
    } catch (err) {
      if (err?.response?.status === 409) {
        toast(err?.response?.data?.message || "Trial already claimed", {
          icon: "ℹ️",
        });
        refreshBillingBalance();
        toggle();
      } else {
        toast.error("Could not claim trial — please try again");
      }
    } finally {
      setClaiming(false);
    }
  };

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle} centered className="paywall-modal">
        <ModalBody className="text-center p-4">
          {trialAvailable ? (
            <>
              <div className="paywall-icon paywall-icon-trial">
                <FaGift />
              </div>
              <h4 className="fw-bold mt-3 mb-2">
                You have {grantAmount} free credits waiting!
              </h4>
              <p className="text-muted" style={{ fontSize: 14 }}>
                {message ||
                  "Claim them to try the AI feature now — no card required."}
              </p>

              <Button
                className="billing-trial-btn w-100 mt-4"
                onClick={handleClaim}
                disabled={claiming}
              >
                {claiming
                  ? "Claiming..."
                  : `Claim ${grantAmount} free credits`}
              </Button>

              <div className="paywall-divider">
                <span>or subscribe to a plan</span>
              </div>

              <div className="d-flex flex-column flex-md-row gap-2">
                <Button
                  className="billing-btn-primary flex-fill"
                  onClick={() => setShowPlans(true)}
                >
                  View plans
                </Button>
                <Button
                  className="billing-btn-secondary flex-fill"
                  onClick={() => setShowTopup(true)}
                >
                  Buy top-up
                </Button>
              </div>
            </>
          ) : (
            <>
              <div className="paywall-icon">
                <FaWandMagicSparkles />
              </div>
              <h4 className="fw-bold mt-3 mb-2">
                You're out of credits
              </h4>
              <p className="text-muted" style={{ fontSize: 14 }}>
                {message ||
                  "Choose a monthly plan or buy top-up credits to continue."}
              </p>

              <div className="paywall-balance">
                <div>
                  <div className="paywall-balance-label">Subscription</div>
                  <div className="paywall-balance-value">{subRemaining}</div>
                </div>
                <div className="paywall-balance-divider" />
                <div>
                  <div className="paywall-balance-label">Wallet</div>
                  <div className="paywall-balance-value">{walletBalance}</div>
                </div>
              </div>

              <div className="d-flex flex-column flex-md-row gap-2 mt-4">
                <Button
                  className="billing-btn-primary flex-fill"
                  onClick={() => setShowPlans(true)}
                >
                  Subscribe to a Plan
                </Button>
                <Button
                  className="billing-btn-secondary flex-fill"
                  onClick={() => setShowTopup(true)}
                >
                  Buy Credits
                </Button>
              </div>
            </>
          )}

          <button type="button" className="paywall-back" onClick={toggle}>
            Back to product form
          </button>
        </ModalBody>
      </Modal>

      <PlansModal
        isOpen={showPlans}
        toggle={() => setShowPlans(false)}
        currentPlanCode={balance?.subscription?.planCode}
      />
      <TopupModal isOpen={showTopup} toggle={() => setShowTopup(false)} />
    </>
  );
};

export default PaywallModal;
